import { createFileRoute } from '@tanstack/react-router';
import { requireOrgAdminBeforeLoad } from '../../../lib/org-admin-guard';

export const Route = createFileRoute('/_authenticated/company/permissions')({
  beforeLoad: requireOrgAdminBeforeLoad
}).lazy(() => import('./permissions.lazy').then((d) => d.Route));
